import request from '@/utils/request'

export function companyAuth(data) {
	return request({
		url: '/api/common/v1/task/companyAuth',
		method: 'post',
		data
	})
}

export function submitCompanyAuthInfo(data) {
	return request({
		url: '/api/common/v1/user/submitCompanyAuthInfo',
		method: 'post',
		data
	})
}

export function getComapnayAuthInfo(data) {
	return request({
		url: '/api/common/v1/manager/audit/getCompanyAuthInfo',
		method: 'post',
		data
	})
}

export function getPersonAuthLink(data) {
	return request({
		url: '/api/common/v1/user/getPersonAuthLink',
		method: 'post',
		data
	})
}

export function getPersonAuthResult(data) {
	return request({
		url: '/api/common/v1/user/getPersonAuthResult',
		method: 'post',
		data
	})
}

export const authorizationAddressPath = "/common/fileTemplate/authorization.pdf"


export function updateCompanyAuthInfo(data) {
	return request({
		url: '/api/common/v1/user/updateCompanyAuthInfo',
		method: 'post',
		data
	})
}

export function getAgentAuthLink(data) {
	return request({
		url: '/api/common/v1/user/getAgentAuthLink',
		method: 'post',
		data
	})
}

export function getAgentAuthResult(data) {
	return request({
		url: '/api/common/v1/user/getAgentAuthResult',
		method: 'post',
		data
	})
}

